import './main.scss'
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom"
import Dashboard from "./pages/Dashboard"
import Home from "./pages/Home"
import Leads from "./pages/Leads"
import Forms from "./pages/Forms"
import CustomiseForm from "./pages/CustomiseForm"
import LoginPage from './pages/LoginPage'
import AddLead from './components/AddLead'
import AddNewModels from './components/AddNewModels'
import Share from "./pages/Share"
import ViewSubmissions from "./pages/ViewSubmissions"
import LeadsPipeView from './components/LeadsPipeView'
import LeadsView from './components/LeadsView'
import { ToastContainer } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'
import Configurations from './components/Configurations'
import CustomField from './components/CustomField'
import AddActivity from './components/AddActivity'
import LeadsManagement from "./pages/LeadsManagement"
import Mailbox from "./pages/Mailbox"
import MailboxLinked from "./pages/MailboxLinked"
import ReadEmail from "./pages/ReadEmail"
import Accounting from "./pages/Accounting"
import Customers from "./pages/Customers"
import Quotes from "./pages/Quotes"
import Invoices from "./pages/Invoices"
import Expenses from "./pages/Expenses"
import RecurringInvoice from './pages/RecurringInvoice'
import QuoteSend from "./pages/QuoteSend"
import EditQuote from "./components/EditQuote"
import InvoiceSend from "./pages/InvoiceSend"
import EditInvoice from "./components/EditInvoice"
import EditExpense from "./components/EditExpense"
import EditCustomer from "./pages/EditCustomer"
import EditRecurringInvoice from "./components/EditRecurringInvoice"
import CreateInvoiceExternal from "./pages/CreateInvoiceExternal"
import InvoiceExternalSend from "./pages/InvoiceExternalSend"
import AccountingExternal from "./pages/AccountingExternal"
import ProtectedRoute from './components/ProtectedRoute'
import Category from './components/Category'
import Products from './components/Products'
import Employee from './pages/Employee'
import OrdersModule from './pages/OrdersModule'
import Attendence from './pages/Attendence'
import Dashboardhome from './pages/Dashboardhome';
import AttendenceData from './pages/AttendenceData'

function App() {
  return (
    <BrowserRouter >
      <ToastContainer position="top-center" />
      <Routes>
        <Route path="/" element={<Navigate to="/login_page" />} />
        <Route path="/login_page" element={<LoginPage />} />
        {/* Protected Routes */}
        <Route
          path="/*"
          element={
            <ProtectedRoute>
              <Routes>
                <Route path="" element={<Dashboard />}>
                  <Route path="/" element={<Home />} />
                  <Route path="/leads" element={<Leads />} >
                    {/* <Route path="/leads/leads-pipe-view" element={<LeadsPipeView />} />
                    <Route path="/leads/leads-view" element={<LeadsView />} /> */}
                    <Route path="" element={<LeadsView />} />
                  </Route>
                  <Route path="/leads/leads-management" element={<LeadsManagement />} />
                  <Route path="/Category" element={<Category />} />
                  <Route path="/Dashboard" element={<Dashboardhome />} />
                  <Route path="/Products" element={<Products />} />
                  <Route path="/Employee" element={<Employee />} />
                  <Route path="/Orders" element={<OrdersModule />} />
                  <Route path="/Attendence" element={<Attendence />} />
                  <Route path="/Attendence/:status" element={<AttendenceData />} />
                  <Route path="/forms" element={<Forms />} />
                  <Route path="/add-lead" element={<AddLead />} />
                  <Route path="/add-activity" element={<AddActivity />} />
                  <Route path="/add-new" element={<AddNewModels />} />
                  <Route path="/customise-form" element={<CustomiseForm />} />
                  <Route path="/view-submissions" element={<ViewSubmissions />} />
                  <Route path="/mailbox" element={<Mailbox />} />
                  <Route path="/mailbox/read/:id" element={<ReadEmail />} />
                  <Route path="/mailbox/oauth" element={<MailboxLinked />} />
                  <Route path="/accounting" element={<Accounting />} >
                    <Route path="/accounting" element={<Customers />} />
                    <Route path="/accounting/customers" element={<Customers />} />
                    <Route path="/accounting/quotes" element={<Quotes />} />
                    <Route path="/accounting/quotes/create/:hash" element={<QuoteSend />} />
                    <Route path="/accounting/quotes/edit/:hash" element={<EditQuote />} />
                    <Route path="/accounting/recurring-invoice" element={<RecurringInvoice />} />
                    <Route path="/accounting/invoices" element={<Invoices />} />
                    <Route path="/accounting/invoices/create/:hash" element={<InvoiceSend />} />
                    <Route path="/accounting/invoices/edit/:hash" element={<EditInvoice />} />
                    <Route path="/accounting/expenses" element={<Expenses />} />
                    <Route path="/accounting/expenses/edit/:hash" element={<EditExpense />} />
                    <Route path="/accounting/customers/edit/:hash" element={<EditCustomer />} />
                    <Route path="/accounting/recurring-invoice/edit/:hash" element={<EditRecurringInvoice />} />
                  </Route>
                  <Route path="/accounting-external" element={<AccountingExternal />}>
                    <Route path="/accounting-external/invoice/create/:identifier" element={<CreateInvoiceExternal />} />
                    <Route path="/accounting-external/invoice/send/:hash" element={<InvoiceExternalSend />} />
                  </Route>
                </Route>
                <Route path="/share/:id" element={<Share />} />
                <Route path="/configuration" element={<Configurations />} />
                <Route path="/customfield" element={<CustomField />} />
              </Routes>
            </ProtectedRoute>
          }
        />
      </Routes>
    </BrowserRouter>
  )
}

export default App
